import BlockIcon from "@mui/icons-material/Block";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
} from "../../../../../components/AdminDashboard/modalStyle";
import { updateOverdue } from "../../../../../services/expositor.service";
import { ModalComponent } from "../../../../../ui-components/Modal";
import { useToast } from "../../../../../ui-components/ToastProvider";

interface Expositor {
  name: string;
  email: string;
  created_at: Date;
  is_admin: boolean;
  full_address: string;
  instagram_url: string;
  brand_name: string;
  address: string;
  id: number;
  phone: string;
  brand_description: string;
  state: string;
  city: string;
  overdue: boolean;
}

export default function BanButton({
  id,
  updateEvents,
  expositor,
}: {
  id: number;
  updateEvents: Function;
  expositor: Expositor;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { showToast } = useToast();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState(expositor.overdue);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = () =>
    updateOverdue(data, expositor.id).then(() => {
      console.log(data);
      showToast("Alterado estado de inadimplência!", { severity: "success" });
      handleClose();
      updateEvents();
    });

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Marcar inadimplência"
        maxWidth={isMobile ? "90%" : 600}
        autoHeight
      >
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Usuário: {expositor?.name} ({expositor?.brand_name})
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 2, color: "#24324D" }}>
            Deseja marcar este usuário como inadimplente?
          </Typography>

          <FormControl fullWidth size={isMobile ? "small" : "medium"}>
            <InputLabel id="overdue-select-label">Estado</InputLabel>
            <Select
              labelId="overdue-select-label"
              id="overdue-select"
              value={data ? 1 : 0}
              label="Estado"
              onChange={(e) => {
                const val = Number(e.target.value);
                setData(Boolean(val));
              }}
            >
              <MenuItem value={0}>Não</MenuItem>
              <MenuItem value={1}>Sim</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: isMobile ? "column" : "row-reverse",
            justifyContent: isMobile ? "flex-end" : "flex-start",
            borderTop: "1px solid",
            borderColor: "divider",
            p: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={adminButtonPrimarySx}
            fullWidth={isMobile}
          >
            Alterar
          </Button>
          <Button
            onClick={handleClose}
            sx={adminButtonOutlinedSx}
            fullWidth={isMobile}
          >
            Cancelar
          </Button>
        </Box>
      </ModalComponent>
      <IconButton
        title="Marcar inadimplência"
        color="warning"
        size={isMobile ? "small" : "medium"}
        onClick={handleOpen}
      >
        <BlockIcon />
      </IconButton>
    </>
  );
}
